module.exports = __webpack_public_path__ + "img/BrandMe_IA_JugadorSuperBowl_9.28465b88.png";